import PublicRoutes from "./PublicRoutes";

const routers = [
    ...PublicRoutes
];

export default routers;